import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfidenceGaugeComponent } from './confidence-gauge.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
    ],
    declarations: [ConfidenceGaugeComponent],
    providers: [],
    exports: [ConfidenceGaugeComponent],
})
export class ConfidenceGaugeModule {
    // static forRoot(): ModuleWithProviders {
    //   return {
    //     ngModule: ConfidenceGaugeModule,
    //     providers: [ConfidenceGaugeService],
    //   };
    // }
}
